import { create } from 'zustand';
import { UserStatus } from '../data/atom'; // Reuse the UserStatus interface

interface UserStore extends UserStatus {
  setUser: (updater: Partial<UserStatus> | ((prev: UserStore) => Partial<UserStatus>)) => void;
  resetUser: () => void;
}

const initialUserState: UserStatus = {
  isLoggedIn: false,
  isSplashShown: false,
  kids: [],
  mainKid: null,
  draftKid: null,
};

export const useUserStore = create<UserStore>((set) => ({
  ...initialUserState,
  setUser: (updater) =>
    set((state) => {
      const updates = typeof updater === 'function' ? updater(state) : updater;
      return { ...state, ...updates };
    }),
  resetUser: () => set(initialUserState),
}));
